// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.input-with-confirm-reset {
  display: inline-flex;
  width: 100%;
}
.input-with-confirm-reset--buttons-at-bottom {
  position: relative;
  margin-bottom: 1.5em;
}
.input-with-confirm-reset--buttons-at-bottom .input-with-confirm-reset__buttons-container {
  position: absolute;
  right: 0;
  top: 100%;
  font-size: 1.5em;
}
.input-with-confirm-reset--buttons-at-bottom .input-with-confirm-reset__icon {
  vertical-align: baseline;
}
.input-with-confirm-reset__text-input {
  height: unset;
}
.input-with-confirm-reset__textarea,
.input-with-confirm-reset__text-input {
  flex: 1;
  min-width: 0;
  line-height: inherit;
  width: 100%;
}
.input-with-confirm-reset__textarea {
  resize: vertical;
}
.input-with-confirm-reset__buttons-container {
  flex: none;
  display: flex;
}
.input-with-confirm-reset__button {
  width: 1.5em;
  height: inherit;
  padding: 0;
  font-size: 75%;
  line-height: inherit;
}
.input-with-confirm-reset__button:disabled {
  cursor: not-allowed;
  color: var(--color-content-disabled);
}
.input-with-confirm-reset__button + .input-with-confirm-reset__button {
  margin: 0;
}
.input-with-confirm-reset__icon {
  vertical-align: middle;
  font-size: unset;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/components/editable-input/input-with-confirm-reset/InputWithConfirmReset.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,oBAAA;EACA,WAAA;AASF;AAPE;EACE,kBAAA;EACA,oBAAA;AASJ;AAXE;EAKI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AASN;AAjBE;EAYI,wBAAA;AAQN;AAJE;EACE,aAAA;AAMJ;AAHE;;EAEE,OAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AAKJ;AAFE;EACE,gBAAA;AAIJ;AADE;EACE,UAAA;EACA,aAAA;AAGJ;AAAE;EACE,YAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;AAEJ;AAAI;EACE,mBAAA;EACA,oCAAA;AAEN;AAEE;EACE,SAAA;AAAJ;AAGE;EACE,sBAAA;EACA,gBAAA;AADJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.input-with-confirm-reset {\n  display: inline-flex;\n  width: 100%;\n\n  &--buttons-at-bottom {\n    position: relative;\n    margin-bottom: 1.5em;\n\n    .input-with-confirm-reset__buttons-container {\n      position: absolute;\n      right: 0;\n      top: 100%;\n      font-size: 1.5em;\n    }\n\n    .input-with-confirm-reset__icon {\n      vertical-align: baseline;\n    }\n  }\n\n  &__text-input {\n    height: unset;\n  }\n\n  &__textarea,\n  &__text-input {\n    flex: 1;\n    min-width: 0;\n    line-height: inherit;\n    width: 100%;\n  }\n\n  &__textarea {\n    resize: vertical;\n  }\n\n  &__buttons-container {\n    flex: none;\n    display: flex;\n  }\n\n  &__button {\n    width: 1.5em;\n    height: inherit;\n    padding: 0;\n    font-size: 75%;\n    line-height: inherit;\n\n    &:disabled {\n      cursor: not-allowed;\n      color: var(--color-content-disabled);\n    }\n  }\n\n  &__button + &__button {\n    margin: 0;\n  }\n\n  &__icon {\n    vertical-align: middle;\n    font-size: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
